import styled from 'styled-components';
import { fadeRevealY } from '../../utils/theme';

export const Container = styled.div`
  display: flex;
  text-align: center;
  margin-bottom: 1.5rem;
  width: 100%;
  div {
    display: flex;
  }
  @media (min-width: 768px) {
    max-width: 35%;
  }
`;

export const DigitContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 0.9rem;
  gap: 0 0.75rem;
  color: ${(prop) => prop.theme.gray};
  opacity: 0;
  width: 100%;

  animation: ${fadeRevealY} 0.15s ease-in forwards 0.3s;
`;

export const Digit = styled.span`
  width: 100%;
  font-size: 5rem;
  color: white;
`;
